//Core
import { Pipe, PipeTransform } from '@angular/core';

import _isObject from 'lodash-es/isObject';
import _isString from 'lodash-es/isString';

@Pipe({ name: 'location', pure: false })
export class LocationPipe implements PipeTransform {
    public transform(value: any, args: any[] = null): string {
        if (!value) {
            return null;
        }

        if (Object.keys(value).length) {
            if (value.code) {
                return value.code;
            }
            return value.airport.code;

        }

        if (_isString(value)) {
            return value;
        }
    }
}
